import Vue from 'vue'
import Vuex from 'vuex'
import global from './global'
import home from './home'
import storage from './storage'
import socket from './socket'
import order from './order'
import storeModule from './store'
import createPersistedState from 'vuex-persistedstate'
import { bootGate } from '@/utils/gate'

Vue.use(Vuex)

const openGateAfterRestore = store => {
	// 確保前面的 persistedstate 已把 state 還原/replace 完畢
	Promise.resolve().then(() => bootGate.open())
}

// shownAnnouncements 為 session 級，每次冷啟動重置，讓「再提醒」的公告重開後能再提醒
const resetShownAnnouncementsAfterRestore = store => {
	store.commit('storage/clearShownAnnouncements')
}

const store = new Vuex.Store({
	plugins: [
		createPersistedState({
			key: 'adminVuex',
			paths: ['storage'],
		}),
		resetShownAnnouncementsAfterRestore,
		openGateAfterRestore,
	],
	modules: { home, storage, socket, order, store: storeModule },
	...global,
})

export default store
